<div class="w-full">
    <mat-dialog-content>
        <h2 mat-dialog-title>{{ title | translate }}</h2>
        <span>{{ text | translate }}</span>
        <section class="py-4">
            <mat-radio-group class="w-full flex justify-between" [(ngModel)]="selected">
                <mat-radio-button *ngFor="let item of data; let i = index" [value]="item"> {{ item | uppercase | translate }} </mat-radio-button>
            </mat-radio-group>
        </section>
    </mat-dialog-content>
    <mat-dialog-actions class="w-full flex justify-between">
        <button mat-flat-button [mat-dialog-close]="false" class="flex-grow bg-tw-disabled">{{'CANCEL'|translate}}</button>
        <button mat-flat-button class="flex-grow bg-tw-primary text-tw-text-light" [disabled]="!isValid" (click)="submit()">{{ valid | translate }}</button>
    </mat-dialog-actions>
</div>